var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "eventStaffingDetailModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c(
        "div",
        { staticClass: "event-detail" },
        [
          _c(
            "div",
            {
              staticClass: "overlay",
              class: {
                isLoading: _vm.getIsLoading,
                noDisplay: !_vm.getIsLoading
              }
            },
            [
              _c(
                "div",
                { staticClass: "spinner-align" },
                [
                  _c("Icon", {
                    staticClass: "icon-size",
                    attrs: { name: "spinner", scale: "5", pulse: "" }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          !_vm.getIsLoading
            ? _c(
                "div",
                {
                  staticClass: "staffing-section margin-side modal-padding",
                  attrs: { id: "staffing-section" }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6 page-title h2-text" }, [
                      _c("span", [_vm._v("Staff & Slot Management")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "seperate-name" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.eventName))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6 noPaddingRight align-right-item"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "modal-close-img",
                            on: {
                              click: function($event) {
                                _vm.back()
                              }
                            }
                          },
                          [_c("div", { staticClass: "icon-close" })]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        { staticClass: "row time-management-container" },
                        [
                          _c("div", { staticClass: "time-slots" }, [
                            _vm._v("\n            Time Management\n          ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "ap-btn btn-cancel",
                              on: {
                                click: function($event) {
                                  _vm.onCancelAllAppointments()
                                }
                              }
                            },
                            [_vm._v("Cancel All Appointments")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "duration-slide-container" }, [
                        _c("div", { staticClass: "staffing-title" }, [
                          _vm._v("\n            slot duration\n          ")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "duration-slide" },
                            [
                              _c(
                                "vue-slider",
                                _vm._b(
                                  {
                                    ref: "slider",
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.getValue("slider")
                                      }
                                    },
                                    model: {
                                      value: _vm.getStaffingDuration,
                                      callback: function($$v) {
                                        _vm.getStaffingDuration = $$v
                                      },
                                      expression: "getStaffingDuration"
                                    }
                                  },
                                  "vue-slider",
                                  _vm.duration,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "ap-btn tertiary change-duration-button"
                            },
                            [_vm._v("change duration")]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col text-entry-field-wrapper" }, [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("ShiftBoard Lead WorkGroup")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.shiftboard.workgroups,
                              placeholder: "Choose Lead WorkGroup",
                              label: "name",
                              openDirection: "below",
                              multiple: false,
                              "close-on-select": true,
                              "hide-selected": true,
                              "track-by": "id",
                              "allow-empty": false,
                              "show-labels": false,
                              disabled: false
                            },
                            on: {
                              select: function($event) {
                                _vm.onShiftboardDropdown($event, "lead")
                              }
                            },
                            model: {
                              value: _vm.shiftboard.leadTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.shiftboard, "leadTitle", $$v)
                              },
                              expression: "shiftboard.leadTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("ShiftBoard Screener WorkGroup")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.shiftboard.workgroups,
                              placeholder: "Choose Screener WorkGroup",
                              label: "name",
                              openDirection: "below",
                              multiple: false,
                              "close-on-select": true,
                              "hide-selected": true,
                              "track-by": "id",
                              "allow-empty": false,
                              "show-labels": false,
                              disabled: false
                            },
                            on: {
                              select: function($event) {
                                _vm.onShiftboardDropdown($event, "screener")
                              }
                            },
                            model: {
                              value: _vm.shiftboard.screenerTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.shiftboard, "screenerTitle", $$v)
                              },
                              expression: "shiftboard.screenerTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "text-entry-title" }, [
                            _vm._v("ShiftBoard Phlebotomist WorkGroup")
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            staticClass: "multiple-select-work-group",
                            attrs: {
                              options: _vm.shiftboard.workgroups,
                              placeholder: "Choose Phlebotomist WorkGroup",
                              label: "name",
                              openDirection: "below",
                              multiple: false,
                              "close-on-select": true,
                              "hide-selected": true,
                              "track-by": "id",
                              "allow-empty": false,
                              "show-labels": false,
                              disabled: false
                            },
                            on: {
                              select: function($event) {
                                _vm.onShiftboardDropdown($event, "phlebotomist")
                              }
                            },
                            model: {
                              value: _vm.shiftboard.phlebotomistTitle,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.shiftboard,
                                  "phlebotomistTitle",
                                  $$v
                                )
                              },
                              expression: "shiftboard.phlebotomistTitle"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12 time-slots" }, [
                      _vm._v("\n          Staff Management\n        ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row staff-management-container" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("StaffManagement", {
                          attrs: {
                            maxValueStaff: _vm.maxStaffLead || 0,
                            eventId: _vm.eventId,
                            staffRole: "lead"
                          },
                          on: {
                            "assign-successful": function($event) {
                              _vm.getEventStaff(_vm.eventId)
                            },
                            "add-remove-staff": _vm.addOrRemoveStaff
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("StaffManagement", {
                          attrs: {
                            maxValueStaff: _vm.maxStaffConcierge || 0,
                            eventId: _vm.eventId,
                            staffRole: "phlebotomist"
                          },
                          on: {
                            "assign-successful": function($event) {
                              _vm.getEventStaff(_vm.eventId)
                            },
                            "add-remove-staff": _vm.addOrRemoveStaff
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12 margin-top-25px" },
                      [
                        _c("StaffManagement", {
                          attrs: {
                            maxValueStaff: _vm.maxStaffScreener || 0,
                            eventId: _vm.eventId,
                            staffRole: "screener"
                          },
                          on: {
                            "assign-successful": function($event) {
                              _vm.getEventStaff(_vm.eventId)
                            },
                            "add-remove-staff": _vm.addOrRemoveStaff
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isLoadingAppointment
                    ? _c("div", {}, [_c("Spinner")], 1)
                    : _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            class: _vm.event.fluShot ? "col-md-6" : "col-md-12"
                          },
                          [
                            _vm.eventDetail
                              ? _c("SlotsTable", {
                                  ref: "updateSlots",
                                  attrs: {
                                    title: "Screeners",
                                    eventDetail: _vm.eventDetail,
                                    eventId: _vm.eventId,
                                    addOns: _vm.event.addOns,
                                    maxValueStaff: _vm.maxAppointmentPerslot,
                                    fluShot: _vm.event.fluShot
                                  },
                                  on: {
                                    updateSlots: _vm.renderEventStaffing,
                                    RELOAD_TABLE_STAFFING:
                                      _vm.requestReloadTableStaffing,
                                    "add-remove-staff": _vm.addOrRemoveStaff
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.event.fluShot !== -1
                          ? _c(
                              "div",
                              { staticClass: "col-md-6" },
                              [
                                _c("SlotsTable", {
                                  ref: "updateSlotsFluShot",
                                  attrs: {
                                    title: "Slots",
                                    eventDetail: _vm.eventDetail,
                                    eventId: _vm.eventId,
                                    addOns: _vm.event.addOns,
                                    fluShot: _vm.event.fluShot
                                  },
                                  on: {
                                    RELOAD_TABLE_STAFFING:
                                      _vm.requestReloadTableStaffing
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("PatientDetailModal"),
          _vm._v(" "),
          _c("ScrollTop"),
          _vm._v(" "),
          _c("ModalCancellAllAppointment", {
            attrs: {
              eventId: _vm.eventId,
              getEventStaffingById: _vm.getEventStaffingById
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0871f9c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0871f9c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/staffing/EventStaffingDetail.vue
// module id = 1733
// module chunks = 1